/**
 * 照片网格组件
 * 以响应式网格布局展示照片缩略图，支持点击打开幻灯片
 */
import type { ShareResponse } from '@photo-process/shared';

import styles from './PhotoGrid.module.css';

/** 单张照片类型（从 ShareResponse 提取） */
type SharePhoto = ShareResponse['photos'][number];

/** PhotoGrid 组件属性 */
interface PhotoGridProps {
  /** 照片列表（不可变数组） */
  readonly photos: readonly SharePhoto[];
  /** 点击照片的回调，参数为照片索引 */
  readonly onPhotoClick: (index: number) => void;
}

/**
 * 照片网格组件
 * 响应式布局：移动端 2 列，平板 3 列，桌面 4 列
 * 支持懒加载和点击查看大图
 */
export function PhotoGrid({ photos, onPhotoClick }: PhotoGridProps): React.JSX.Element {
  if (photos.length === 0) {
    return (
      <p style={{ textAlign: 'center', color: '#999', padding: '2rem 0' }}>
        该分享中暂无照片
      </p>
    );
  }

  return (
    <ul className={styles.grid} role="list" aria-label="照片网格">
      {photos.map((photo, index) => (
        <li key={photo.id} className={styles.item}>
          <button
            type="button"
            onClick={() => onPhotoClick(index)}
            aria-label={`查看照片 ${photo.filename}`}
            style={{
              all: 'unset',
              display: 'block',
              width: '100%',
              height: '100%',
              cursor: 'pointer',
            }}
          >
            <img
              className={styles.image}
              src={photo.url}
              alt={photo.filename}
              loading="lazy"
              width={photo.width}
              height={photo.height}
            />
          </button>
        </li>
      ))}
    </ul>
  );
}
